import { cols } from "@/config/system";

export const tableColumn = [
  {
    type: "index",
    label: "序号",
    disabled: true,
    width: cols.number
  },
  {
    label: "地址",
    prop: "area",
    width: cols.auto,
  },
  {
    label: "可达情况",
    prop: "isAbnormalArea",
    width: cols.auto,
    slotName: "abnormalArea"
  },
];
